"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSingleNodeEdgeMapperQuery = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const util_1 = require("../util");
const getSingleNodeEdgeMapperQuery = ({ item }) => {
    const outBQD = new util_1.BranchingQueryDefinition({
        id: 'outVs',
        path: [
            {
                objectTypeId: '*',
                adjacencyType: iotv_v3_types_1.AdjacentType.CHILD
            }
        ],
        subQueries: []
    });
    const inBQD = new util_1.BranchingQueryDefinition({
        id: 'inVs',
        path: [
            {
                objectTypeId: '*',
                adjacencyType: iotv_v3_types_1.AdjacentType.PARENT
            }
        ],
        subQueries: []
    });
    return new util_1.BranchingQueryDefinition({
        id: 'apex',
        path: [
            {
                objectTypeId: item.type,
                adjacencyType: iotv_v3_types_1.AdjacentType.SUBJECT,
            }
        ],
        subQueries: [outBQD, inBQD]
    });
};
exports.getSingleNodeEdgeMapperQuery = getSingleNodeEdgeMapperQuery;
